import { CookieManager } from './../../Utilities/CookieManager';
import "./Recommendations.scss";

import { Cart } from "@Utilities/Cart";
import { Tenant } from "@Utilities/Tenant";
import { TextResource } from "@Utilities/TextResource";
import { TrackingService } from "@Api/TrackingService";

import HcProductCard from "@Tenants/Hc/Templates/ProductCard.hbs";
import HcHoverRecs from "@Tenants/Hc/Templates/HoverRecs.hbs";
import FunProductCard from "@Tenants/Fun/Templates/ProductCard.hbs";
import RecentlyViewedSide from "@Templates/RecentlyViewedSide.hbs";
import axios from "axios";
import { Media } from "@Utilities/Media";
import enquire from "enquire.js";
import { Fancyapps } from "@Libraries/Fancyapps";

class Product
{
	public CurrencySymbol;
	public Exclusive;
	public HasPriceRange;
	public HasSavings;
	public ImageLink;
	public ImageLinkLarge;
	public ImageLinkMedium;
	public ImageLinkXLarge;
	public IsOnClearance;
	public IsOnSale;
	public IsPreOrder;
	public IsSingleSize;
	public IsSingleSizeNotStandard;
	public Link;
	public MadeByUs;
	public MaxOriginalPrice;
	public MaxPrice;
	public MinOriginalPrice;
	public MinPrice;
	public ProductID;
	public Rating;
	public RatingDescription;
	public Ratings;
	public RefreshExclusiveMadeByUsTag;
	public RefreshShowExclusive;
	public RRLink;
	public Savings;
	public Sizes;
	public Title;

	constructor(productID, sizes, title, link, imageLink, price, isOnClearance, isOnSale, isPreOrder, rating, currencySymbol, exclusive, madeByUs, rrLink)
	{
		let savings = 0;
		let sizeCount = 0;
		let sizeStandard = false;
		const youSaveThreshold = 0.05;
		let maxPrice = 0;
		let minPrice = 0;
		let maxRegularPrice = 0;
		let minRegularPrice = 0;
		price = (price * 1);

		if (sizes.length > 0)
		{
			for (let k = 0; k < sizes.length; k++)
			{
				if (sizes[k].DisplayPrice > maxPrice || maxPrice === 0) maxPrice = sizes[k].DisplayPrice.toFixed(2);
				if (sizes[k].DisplayPrice < minPrice || minPrice === 0) minPrice = sizes[k].DisplayPrice.toFixed(2);
				if (sizes[k].RegularPrice > maxRegularPrice || maxRegularPrice === 0) maxRegularPrice = sizes[k].RegularPrice.toFixed(2);
				if (sizes[k].RegularPrice < minRegularPrice || minRegularPrice === 0) minRegularPrice = sizes[k].RegularPrice.toFixed(2);
			}
		}
		else
		{
			maxPrice = price.toFixed(2);
			minPrice = price.toFixed(2);
			maxRegularPrice = price.toFixed(2);
			minRegularPrice = price.toFixed(2);
		}

		this.CurrencySymbol = currencySymbol;
		this.Exclusive = exclusive;
		this.ImageLink = imageLink;
		this.ImageLinkMedium = imageLink.replace("/1-5/", "/1-4/");
		this.ImageLinkLarge = imageLink.replace("/1-5/", "/1-21/");
		this.ImageLinkXLarge = imageLink.replace("/1-5/", "/1-2/");
		this.IsOnSale = isOnSale;
		this.IsPreOrder = isPreOrder;
		this.Link = link;
		this.MadeByUs = madeByUs;
		this.MaxOriginalPrice = maxRegularPrice;
		this.MaxPrice = maxPrice;
		this.MinOriginalPrice = minRegularPrice;
		this.MinPrice = minPrice;
		this.ProductID = productID;
		this.Rating = rating;
		this.RefreshExclusiveMadeByUsTag = (madeByUs || exclusive);
		this.RefreshShowExclusive = (exclusive && !(madeByUs && (isPreOrder || isOnClearance || isOnSale)));
		this.RRLink = rrLink;
		this.Sizes = sizes;
		this.Title = title.replace(/"/g, '\\"');

		// Calculations
		this.HasPriceRange = this.MinPrice > 0 && this.MinPrice !== this.MaxPrice;

		// Ratings
		if (this.Rating > 0)
		{
			let description = TextResource.GetTextByCulture('Word_Stars');
			const ratingMod = this.Rating % 1;
			const ratings = [];
			let currentRating = "";

			if (this.Rating === 1)
			{
				description = TextResource.GetTextByCulture('Word_Star');
			}

			for (let j = 1; j <= 5; j++)
			{
				if (j <= this.Rating)
				{
					currentRating = "rating-star-filled";
				}
				else if (j > this.Rating && this.Rating > j - 1)
				{
					if (ratingMod === 0)
					{
						currentRating = "rating-star-empty";
					}
					else if (ratingMod <= 0.5)
					{
						currentRating = "rating-star-50";
					}
					else if (ratingMod > 0.5)
					{
						currentRating = "rating-star-filled";
					}
				}
				else
				{
					currentRating = "rating-star-empty";
				}

				ratings.push(currentRating);
			}

			this.RatingDescription = this.Rating + " " + description;
			this.Ratings = ratings;
		}

		if (this.Sizes.length)
		{
			sizeCount = this.Sizes.length;

			for (let i = 0; i < this.Sizes.length; i++)
			{
				if (i === 0 && this.Sizes.length === 1)
				{
					if (this.Sizes[i].Size === "ST" || this.Sizes[i].Size === "one-size")
					{
						sizeStandard = true;
					}
				}
			}
		}

		this.IsSingleSize = sizeCount <= 1;
		this.IsSingleSizeNotStandard = !sizeStandard;

		savings = 1.0 - this.MinPrice / this.MaxOriginalPrice;

		if (savings > youSaveThreshold)
		{
			this.HasSavings = true;
			this.IsOnClearance = isOnClearance;
			this.Savings = Math.round(savings * 100);
		}
		else
		{
			this.HasSavings = false;
			this.IsOnClearance = false;
			this.Savings = 0;
		}
	}
}

class ProductCarousel
{
	public CarouselID;
	public CarouselTitle;
	public Products;

	constructor(carouselID, carouselTitle, products)
	{
		this.CarouselID = carouselID;
		this.CarouselTitle = carouselTitle;
		this.Products = products;
	}
}

///<summary>A product size object.</summary>
class ProductSize
{
	public DisplayOrder;
	public DisplayPrice;
	public RegularPrice;
	public Size;
	public SizeID;

	constructor(sizeID, size, displayPrice, regularPrice, displayOrder)
	{
		this.Size = size;

		this.SizeID = parseInt(sizeID, 10);
		this.SizeID = isNaN(this.SizeID) ? 0 : this.SizeID;

		this.DisplayPrice = parseFloat(displayPrice);
		this.DisplayPrice = isNaN(this.DisplayPrice) ? 0 : this.DisplayPrice;

		this.RegularPrice = parseFloat(regularPrice);
		this.RegularPrice = isNaN(this.RegularPrice) ? 0 : this.RegularPrice;

		this.DisplayOrder = parseInt(displayOrder, 10);
		this.DisplayOrder = isNaN(this.DisplayOrder) ? 0 : this.DisplayOrder;
	}
}

export class Recommendations
{
	public ReferrerCategoryID = 0;
	public ReferringCategoryAsyncAPI = false;
	public GetReferringCategoryCallback = null;

	private readonly cart: Cart;
	private readonly trackingService: TrackingService;

	constructor()
	{
		this.cart = new Cart();
		this.trackingService = new TrackingService();
	}

	// PUBLIC FUNCTIONS
	///<summary>Adds a product to the cart.</summary>
	public FunAddToCart = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;

		const mysteryJson = document.getElementById("MysteryBoxesJson") as HTMLInputElement;
		const recOne = document.getElementById("rec-one") as HTMLElement;
		const recTwo = document.getElementById("rec-two") as HTMLElement;
		const recThree = document.getElementById("rec-three") as HTMLElement;
		const recFour = document.getElementById("rec-four") as HTMLElement;
		const recAtcOne = document.getElementById("rec-atc-one") as HTMLElement;

		if (mysteryJson !== null)
		{
			this.FunMysteryBoxLocal(mysteryJson.value);
		}

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "add_to_cart_page.rr1":
					if (recFour !== null)
					{
						carousel = new ProductCarousel("rec-four", TextResource.GetTextByCulture('Feature_Recommendations_RecentlyViewed'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recFour.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-four");
					}

					else if (recAtcOne !== null)
					{
						// carousel = new ProductCarousel("rec-atc-one", TextResource.GetTextByCulture('Feature_Recommendations_Products'), recommendationList[key]);
						// html = GetContainer(carousel, "addToCartBottom");
						// $("#rec-atc-one").replaceWith(html);
						// Fun.Cart.Quick.Initialize();
					}
					break;

				case "add_to_cart_page.rr2":
					if (recTwo !== null)
					{
						carousel = new ProductCarousel("rec-two", TextResource.GetTextByCulture('Feature_Recommendations_AlsoBought'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recTwo.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-two");
					}
					break;
				case "add_to_cart_page.rr3":
					if (recThree !== null)
					{
						carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_RelatedCart'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recThree.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-three");
					}
					break;
				case "add_to_cart_page.rr4":
					if (recOne !== null)
					{
						carousel = new ProductCarousel("rec-one", TextResource.GetTextByCulture('Feature_Recommendations_Products'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recOne.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-one");
					}
					break;
			}
		}
	};

	///<summary>Displays recommendations on categories for HC.com.</summary>
	public FunCategory = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "category_page.rr1":
				case "category_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;
			}
		}
	};

	// ///<summary>Displays recommendations on the add to cart confirmation dialog for Fun.com.</summary>
	// public FunConfirmation = function (rawData)
	// {
	// 	const recommendationList = this.HydrateRecommendations(rawData);
	// 	let html = "";
	// 	let carousel = void 0;

	// 	for (const key in recommendationList)
	// 	{
	// 		if (key === "purchase_complete_page.rr1" || key === "purchase_complete_page.m-rr1")
	// 		{
	// 			carousel = new ProductCarousel("rec-recent", TextResource.GetTextByCulture('Feature_Recommendations_ComingSoon'), recommendationList[key]);
	// 			carousel.AddToCart = true;
	// 			html = this.GetContainer(carousel, "funProductCard");
	// 			$("#rec-recent").replaceWith(html);
	// 			this.ConfigureThemeAddItems("#rec-recent");
	// 		}
	// 	}
	// };

	///<summary>Displays recommendations on the home page for Fun.com.</summary>
	public FunHome = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "home_page.rr1":
				case "home_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				// At one point, direction was given from marketing, that the container that's above the fold should not contain prices.
				// If this is added onto the site and that's still the case, the handlebars template will need to be updates to allow this.
				//case "home_page.rr2":
				//	if ($("#rec-trend").length)
				//	{
				//		carousel = new ProductCarousel("rec-trend", rawData[1].strategy_message, recommendationList[key]);
				//		html = this.GetContainer(carousel, "hcFourUp");
				//		$("#rec-trend").replaceWith(html);

				//		this.ConfigureFourUpItems("#rec-trend", recommendationList[key].length);
				//		this.ConfigureThemeAddItems("#rec-trend");
				//	}

				//	break;
			}
		}
	};

	// public FunEmptyCart = function (rawData)
	// {
	// 	const recommendationList = this.HydrateRecommendations(rawData);
	// 	let html = "";
	// 	let carousel = void 0;

	// 	for (const key in recommendationList)
	// 	{
	// 		switch (key)
	// 		{
	// 			case "cart_page.emptycartrr1":
	// 				if ($("#rec-one").length)
	// 				{
	// 					carousel = new ProductCarousel("rec-one", TextResource.GetTextByCulture('Feature_Recommendations_PopularProducts'), recommendationList[key]);
	// 					carousel.AddToCart = true;
	// 					html = this.GetContainer(carousel, "funProductCard");
	// 					$("#rec-one").replaceWith(html);
	// 					this.ConfigureThemeAddItems("#rec-one");
	// 				}
	// 				break;
	// 			case "cart_page.emptycartrr2":
	// 				if ($("#rec-recent").length)
	// 				{
	// 					carousel = new ProductCarousel("rec-recent", rawData[1].strategy_message, recommendationList[key]);
	// 					carousel.AddToCart = true;
	// 					html = this.GetContainer(carousel, "funProductCard");
	// 					$("#rec-recent").replaceWith(html);
	// 					this.ConfigureThemeAddItems("#rec-recent");
	// 				}
	// 				break;
	// 		}
	// 	}
	// };

	public FunMysteryBoxLocal = (rawData): void =>
	{
		const recommendationList = this.HydrateLocalPlacement("mystery-box", rawData);
		let html = "";
		let carousel = void 0;

		const rec = document.getElementById("rec-mystery") as HTMLElement;

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "mystery-box":
					if (rec !== null)
					{
						carousel = new ProductCarousel("rec-mystery", TextResource.GetTextByCulture('Feature_Recommendations_MysteryBoxes'), recommendationList[key]);
						carousel.AddToCart = true;
						carousel.EnableSlider = true;
						html = FunProductCard(carousel);
						rec.outerHTML = html;
						this.ConfigureFourUpCarousel("#rec-mystery");
						this.ConfigureThemeAddItems("#rec-mystery");

						//output product ids to block from RR repeating in other containers.
						for (let i = 0; i < recommendationList["mystery-box"].length; i++)
						{
							const container = document.getElementById("rec-mystery") as HTMLElement;
							const exclusionContainer = document.createElement("div");
							exclusionContainer.classList.add("exclude-product");
							exclusionContainer.style.display = "none";
							exclusionContainer.innerHTML = recommendationList["mystery-box"][i].ProductID;
							container.appendChild(exclusionContainer);

							//only exclude the first 8 items
							if (i == 7)
							{
								break;
							}
						}
					}
					break;
			}
		}
	};

	// ///<summary>Displays recommendations on the product details page for Fun.com.</summary>
	public FunProduct = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;

		const mysteryJson = document.getElementById("MysteryBoxesJson") as HTMLInputElement;
		const recRecent = document.getElementById("rec-recent") as HTMLElement;
		const recRecentSide = document.getElementById("rec-recent-side") as HTMLElement;
		const rec2 = document.getElementById("rec-two") as HTMLElement;
		const rec3 = document.getElementById("rec-three") as HTMLElement;

		if (mysteryJson !== null)
		{
			this.FunMysteryBoxLocal(mysteryJson.value);
		}

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "item_page.rr1":
					if (recRecentSide !== null)
					{
						this.ConfigureRightItems(recommendationList[key], recRecentSide);
					}
					break;

				case "item_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}
					break;

				case "item_page.rr2":
				case "item_page.m-rr2":
					if (rec2 !== null)
					{
						carousel = new ProductCarousel("rec-two", TextResource.GetTextByCulture('Feature_Recommendations_AlsoViewed'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						rec2.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-two");
					}
					break;

				case "item_page.rr3":
				case "item_page.m-rr3":
					if (rec3 !== null)
					{
						carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_Products'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						rec3.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-three");
					}
					break;
			}
		}
	};

	///<summary>Displays recommendations on the search results page for Fun.com.</summary>
	public FunSearch = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");
		const recNoSearch = document.querySelector("#rec-nosearch");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "search_page.rr1":
				case "search_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				case "search_page.rr2":
					if (recNoSearch !== null)
					{
						carousel = new ProductCarousel("rec-nosearch", TextResource.GetTextByCulture('Feature_Recommendations_Searched'), recommendationList[key]);
						carousel.AddToCart = true;
						html = FunProductCard(carousel);
						recNoSearch.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-nosearch");
					}

					break;
			}
		}
	};

	public HalloweenAddToCart = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;

		const accJson = document.getElementById("RelatedAccessoriesJson") as HTMLInputElement;
		const recTwo = document.getElementById("rec-two") as HTMLElement;
		const recThree = document.getElementById("rec-three") as HTMLElement;
		const recFour = document.getElementById("rec-four") as HTMLElement;

		if (accJson !== null)
		{
			this.HalloweenAddToCartLocal(accJson.value);
		}

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "add_to_cart_page.rr-1":
					if (recTwo !== null)
					{
						carousel = new ProductCarousel("rec-two", TextResource.GetTextByCulture('Feature_Recommendations_AlsoBought'), recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recTwo.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-two");
					}
					break;

				case "add_to_cart_page.rr-2":
					if (recThree !== null)
					{
						carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_RelatedCart'), recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recThree.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-three");
					}
					break;

				case "add_to_cart_page.rr-3":
					if (recFour !== null)
					{
						let title = "";
						if (rawData[0].strategy_message == TextResource.GetTextByCulture('Feature_Recommendations_RecentlyViewed'))
						{
							title = TextResource.GetTextByCulture('Feature_Recommendations_RecentlyViewed');
						}
						else
						{
							title = TextResource.GetTextByCulture('Feature_Recommendations_TrendingProducts');
						}

						carousel = new ProductCarousel("rec-four", title, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recFour.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-four");
					}
					break;
			}
		}
	};

	public HalloweenAddToCartLocal = (rawData): void =>
	{
		const recommendationList = this.HydrateLocalPlacement("add-to-cart", rawData);
		let html = "";
		let carousel = void 0;

		const recOne = document.getElementById("rec-one") as HTMLElement;

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "add-to-cart":
					if (recOne !== null)
					{
						carousel = new ProductCarousel("rec-one", TextResource.GetTextByCulture('Feature_Recommendations_Accessories'), recommendationList[key]);
						carousel.AddToCart = true;
						carousel.EnableSlider = true;
						html = HcProductCard(carousel);
						recOne.outerHTML = html;
						this.ConfigureFourUpCarousel("#rec-one");
						this.ConfigureThemeAddItems("#rec-one");

						//output product ids to block from RR repeating in other containers.
						for (let i = 0; i < recommendationList["add-to-cart"].length; i++)
						{
							const container = document.getElementById("rec-one") as HTMLElement;
							const exclusionContainer = document.createElement("div");
							exclusionContainer.classList.add("exclude-product");
							exclusionContainer.style.display = "none";
							exclusionContainer.innerHTML = recommendationList["add-to-cart"][i].ProductID;
							container.appendChild(exclusionContainer);

							//only exclude the first 8 items
							if (i == 7)
							{
								break;
							}
						}
					}
					break;
			}
		}
	};

	public HalloweenCategory = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "category_page.rr-1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;
			}
		}
	};

	public HalloweenHome = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "home_page.rr-1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;
			}
		}
	};

	public HalloweenProduct = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;

		const recRecent = document.getElementById("rec-recent") as HTMLElement;
		const rec2 = document.getElementById("rec-two") as HTMLElement;
		const rec3 = document.getElementById("rec-three") as HTMLElement;

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "item_page.rr-1":
					if (rec2 !== null)
					{
						const productTypeID = document.getElementById("ProductTypeID").getAttribute("value");
						let carouselTitle = "";

						if (productTypeID === "11")
						{
							carouselTitle = TextResource.GetTextByCulture("Feature_Recommendations_Decorations");
						}
						else
						{
							carouselTitle = TextResource.GetTextByCulture('Feature_Recommendations_Costumes');
						}

						carousel = new ProductCarousel("rec-two", carouselTitle, recommendationList[key]);
						html = HcHoverRecs(carousel);
						rec2.outerHTML = html;
					}
					break;

				case "item_page.rr-2":
					if (rec3 !== null)
					{
						carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_For_You'), recommendationList[key]);
						html = HcHoverRecs(carousel);
						rec3.outerHTML = html;
					}
					break;

				case "item_page.rr-3":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", TextResource.GetTextByCulture('Feature_Recommendations_RecentlyViewed'), recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;
			}
		}
	};

	public HalloweenSearch = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");
		const recNoSearch = document.querySelector("#rec-nosearch");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "search_page.rr-1":
					if (recNoSearch !== null)
					{
						carousel = new ProductCarousel("rec-nosearch", TextResource.GetTextByCulture('Feature_Recommendations_Searched'), recommendationList[key]);
						carousel.AddToCart = true;
						carousel.EnableSlider = true;
						html = HcProductCard(carousel);
						recNoSearch.outerHTML = html;
						this.ConfigureFourUpCarousel("#rec-nosearch");
						this.ConfigureThemeAddItems("#rec-nosearch");
					}
					break;

				case "search_page.rr-2":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}
					break;
			}
		}
	};

	public HCAddToCart = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;

		const accJson = document.getElementById("RelatedAccessoriesJson") as HTMLInputElement;
		const recTwo = document.getElementById("rec-two") as HTMLElement;
		const recThree = document.getElementById("rec-three") as HTMLElement;
		const recFour = document.getElementById("rec-four") as HTMLElement;

		if (accJson !== null)
		{
			this.HCAddToCartLocal(accJson.value);
		}

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "add_to_cart_page.rr1":
					if (recFour !== null)
					{
						let title = "";
						if (rawData[0].strategy_message == TextResource.GetTextByCulture('Feature_Recommendations_RecentlyViewed'))
						{
							title = TextResource.GetTextByCulture('Feature_Recommendations_RecentlyViewed');
						}
						else
						{
							title = TextResource.GetTextByCulture('Feature_Recommendations_TrendingProducts');
						}

						carousel = new ProductCarousel("rec-four", title, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recFour.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-four");
					}
					break;
				case "add_to_cart_page.rr2":
					if (recTwo !== null)
					{
						carousel = new ProductCarousel("rec-two", TextResource.GetTextByCulture('Feature_Recommendations_AlsoBought'), recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recTwo.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-two");
					}
					break;
				case "add_to_cart_page.rr3":
					if (recThree !== null)
					{
						carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_RelatedCart'), recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recThree.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-three");
					}
					break;
			}
		}
	};

	public HCAddToCartLocal = (rawData): void =>
	{
		const recommendationList = this.HydrateLocalPlacement("add-to-cart", rawData);
		let html = "";
		let carousel = void 0;

		const recOne = document.getElementById("rec-one") as HTMLElement;

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "add-to-cart":
					if (recOne !== null)
					{
						carousel = new ProductCarousel("rec-one", TextResource.GetTextByCulture('Feature_Recommendations_Accessories'), recommendationList[key]);
						carousel.AddToCart = true;
						carousel.EnableSlider = true;
						html = HcProductCard(carousel);
						recOne.outerHTML = html;
						this.ConfigureFourUpCarousel("#rec-one");
						this.ConfigureThemeAddItems("#rec-one");

						//output product ids to block from RR repeating in other containers.
						for (let i = 0; i < recommendationList["add-to-cart"].length; i++)
						{
							const container = document.getElementById("rec-one") as HTMLElement;
							const exclusionContainer = document.createElement("div");
							exclusionContainer.classList.add("exclude-product");
							exclusionContainer.style.display = "none";
							exclusionContainer.innerHTML = recommendationList["add-to-cart"][i].ProductID;
							container.appendChild(exclusionContainer);

							//only exclude the first 8 items
							if (i == 7)
							{
								break;
							}
						}
					}
					break;
			}
		}
	};

	///<summary>Displays recommendations on categories for HC.com.</summary>
	public HCCategory = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");
		const recForYou = document.querySelector("#rec-foryou");
		const isRefresh = document.querySelector(".catRefresh") !== null;

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "category_page.rr1":
				case "category_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				case "category_page.rr2":
					if (recForYou !== null)
					{
						carousel = new ProductCarousel("rec-foryou", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recForYou.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-foryou");
					}

					break;
			}
		}
	};

	// ///<summary>Displays recommendations on the add to cart confirmation dialog for HC.com.</summary>
	// public HCConfirmation = function (rawData)
	// {
	// 	const recommendationList = this.HydrateRecommendations(rawData);
	// 	let html = "";
	// 	let carousel = void 0;
	// 	const title = "";

	// 	for (const key in recommendationList)
	// 	{
	// 		switch (key)
	// 		{
	// 			case "purchase_complete_page.rr1":
	// 			case "purchase_complete_page.m-rr1":
	// 				if ($("#rec-recent").length)
	// 				{
	// 					carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
	// 					carousel.AddToCart = false;
	// 					html = this.GetContainer(carousel, "hcFourUp");
	// 					$("#rec-recent").replaceWith(html);

	// 					this.ConfigureFourUpItems("#rec-recent", recommendationList[key].length, true);
	// 					this.ConfigureThemeAddItems("#rec-recent");
	// 				}
	// 				break;

	// 			case "purchase_complete_page.hc_orderconfirmation":
	// 				if ($("#rec-fun").length)
	// 				{
	// 					for (let i = 0; i < recommendationList[key].length; i++)
	// 					{
	// 						recommendationList[key][i].Link = "https://www.fun.com" + recommendationList[key][i].Link;
	// 					}

	// 					carousel = new ProductCarousel("rec-fun", TextResource.GetTextByCulture('Feature_Recommendations_TrendingOnFun'), recommendationList[key]);
	// 					carousel.AddToCart = false;
	// 					html = this.GetContainer(carousel, "hcFourUp");
	// 					$("#rec-fun").replaceWith(html);

	// 					this.ConfigureFourUpItems("#rec-fun", recommendationList[key].length);
	// 					this.ConfigureThemeAddItems("#rec-fun");
	// 				}
	// 		}
	// 	}
	// };

	///<summary>Displays recommendations on the home page for HC.com.</summary>
	public HCGroupBuilderReview = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const accJson = document.getElementById("RelatedAccessoriesJson") as HTMLInputElement;
		const recForYou = document.querySelector("#rec-foryou");

		if (accJson !== null)
		{
			this.HCAddToCartLocal(accJson.value);
		}

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "add_to_cart_page.groupbuilderreview":
					if (recForYou !== null)
					{
						carousel = new ProductCarousel("rec-foryou", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recForYou.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-foryou");
					}

					break;
			}
		}
	};

	///<summary>Displays recommendations on the home page for HC.com.</summary>
	public HCHome = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "home_page.rr1":
				case "home_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				// At one point, direction was given from marketing, that the container that's above the fold should not contain prices.
				// If this is added onto the site and that's still the case, the handlebars template will need to be updates to allow this.
				//case "home_page.rr2":
				//	if ($("#rec-trend").length)
				//	{
				//		carousel = new ProductCarousel("rec-trend", rawData[1].strategy_message, recommendationList[key]);
				//		html = this.GetContainer(carousel, "hcFourUp");
				//		$("#rec-trend").replaceWith(html);

				//		this.ConfigureFourUpItems("#rec-trend", recommendationList[key].length);
				//		this.ConfigureThemeAddItems("#rec-trend");
				//	}

				//	break;
			}
		}
	};

	// public HCEmptyCart = function (rawData)
	// {
	// 	const recommendationList = this.HydrateRecommendations(rawData);
	// 	let html = "";
	// 	let carousel = void 0;

	// 	for (const key in recommendationList)
	// 	{
	// 		switch (key)
	// 		{
	// 			case "cart_page.emptycartrr1":

	// 				if ($("#rec-recent").length)
	// 				{
	// 					carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
	// 					carousel.AddToCart = true;
	// 					html = this.GetContainer(carousel, "hcFourUp");
	// 					$("#rec-recent").replaceWith(html);
	// 				}

	// 				this.ConfigureFourUpItems("#rec-recent", recommendationList[key].length, true);
	// 				this.ConfigureThemeAddItems("#rec-recent");

	// 				break;

	// 			case "cart_page.emptycartrr2":
	// 				if ($("#rec-one").length)
	// 				{
	// 					carousel = new ProductCarousel("rec-one", rawData[1].strategy_message, recommendationList[key]);
	// 					carousel.AddToCart = true;
	// 					html = this.GetContainer(carousel, "hcFourUp");
	// 					$("#rec-one").replaceWith(html);
	// 				}

	// 				this.ConfigureFourUpItems("#rec-one", recommendationList[key].length, true);
	// 				this.ConfigureThemeAddItems("#rec-one");

	// 				break;
	// 		}
	// 	}
	// };

	// ///<summary>Displays recommendations on the product details page for HC.com.</summary>
	public HCProduct = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;

		const recRecent = document.getElementById("rec-recent") as HTMLElement;
		const recRecent2 = document.getElementById("rec-recent2") as HTMLElement;
		const recRecentSide = document.getElementById("rec-recent-side") as HTMLElement;
		const rec2 = document.getElementById("rec-two") as HTMLElement;
		const rec3 = document.getElementById("rec-three") as HTMLElement;

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "item_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				case "item_page.m-rr1variant":
					if (recRecent2 !== null)
					{
						carousel = new ProductCarousel("rec-recent2", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent2.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent2");
					}

					break;

				case "item_page.rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				case "item_page.rr2":
				case "item_page.m-rr2":
					if (rec2 !== null)
					{
						const productTypeID = document.getElementById("ProductTypeID").getAttribute("value");
						let carouselTitle = "";

						if (productTypeID === "11")
						{
							carouselTitle = TextResource.GetTextByCulture("Feature_Recommendations_Decorations");
						}
						else
						{
							carouselTitle = TextResource.GetTextByCulture('Feature_Recommendations_Costumes');
						}

						carousel = new ProductCarousel("rec-two", carouselTitle, recommendationList[key]);
						html = HcHoverRecs(carousel);
						rec2.outerHTML = html;

						// this.ConfigureHoverRecsCarousel("#rec-two");
					}
					break;

				case "item_page.rr3":
					if (rec3 !== null)
					{
						carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_For_You'), recommendationList[key]);
						html = HcHoverRecs(carousel);
						rec3.outerHTML = html;
					}
					break;
			}
		}

		// const recommendationList = this.HydrateRecommendations(rawData);
		// let html = "";
		// let carousel = void 0;
		// const recRecent = document.getElementById("rec-recent");
		// const recRecent2 = document.getElementById("rec-recent2");
		// const recRecentSide = document.getElementById("rec-recent-side");
		// const recTwo = document.getElementById("rec-two");
		// const recThree = document.getElementById("rec-three");

		// for (const key in recommendationList)
		// {
		// 	switch (key)
		// 	{
		// 		case "item_page.m-rr1":

		// 			if (recRecent !== null)
		// 			{
		// 				// carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
		// 				// carousel.AddToCart = true;
		// 				// html = this.GetContainer(carousel, "hcFourUp");
		// 				// $("#rec-recent").replaceWith(html);

		// 				carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
		// 				carousel.AddToCart = true;
		// 				html = HcProductCard(carousel);
		// 				recRecent.outerHTML = html;
		// 				this.ConfigureThemeAddItems("#rec-recent");
		// 			}

		// 			break;

		// 		case "item_page.m-rr1variant":

		// 			if (recRecent2 !== null)
		// 			{
		// 				carousel = new ProductCarousel("rec-recent2", rawData[0].strategy_message, recommendationList[key]);
		// 				carousel.AddToCart = true;
		// 				html = this.GetContainer(carousel, "hcFourUp");
		// 				$("#rec-recent2").replaceWith(html);
		// 			}

		// 			this.ConfigureFourUpItems("#rec-recent2", recommendationList[key].length, true);
		// 			this.ConfigureThemeAddItems("#rec-recent2");

		// 			break;

		// 		case "item_page.rr1":
		// 			if (recRecentSide !== null)
		// 			{
		// 				this.ConfigureRightItems(recommendationList[key]);
		// 			}

		// 			break;

		// 		case "item_page.rr2":
		// 		case "item_page.m-rr2":
		// 			if (recTwo !== null)
		// 			{
		// 				const productTypeID = $("#ProductTypeID").val();
		// 				let carouselTitle = "";

		// 				if (productTypeID === "11")
		// 				{
		// 					carouselTitle = TextResource.GetTextByCulture("Feature_Recommendations_Accessories");
		// 				}
		// 				else
		// 				{
		// 					carouselTitle = TextResource.GetTextByCulture('Feature_Recommendations_Costumes');
		// 				}

		// 				carousel = new ProductCarousel("rec-two", carouselTitle, recommendationList[key]);
		// 				html = this.GetContainer(carousel, "productRelatedRowHover");
		// 				$("#rec-two").replaceWith(html);

		// 				this.ConfigureBottomItems("#rec-two", recommendationList[key].length);
		// 			}
		// 			break;

		// 		case "item_page.rr3":
		// 			if (recThree !== null)
		// 			{
		// 				carousel = new ProductCarousel("rec-three", TextResource.GetTextByCulture('Feature_Recommendations_For_You'), recommendationList[key]);
		// 				html = this.GetContainer(carousel, "productRelatedRowHover");
		// 				$("#rec-three").replaceWith(html);

		// 				this.ConfigureBottomItems("#rec-three", recommendationList[key].length);
		// 			}
		// 			break;
		// 	}
		//}

		// if ($(".rel-thm").length)
		// {
		// 	this.ConfigureThemeItems(".rel-thm .nameprc .name a");
		// }
	};

	///<summary>Displays recommendations on the search results page for HC.com.</summary>
	public HCSearch = (rawData): void =>
	{
		const recommendationList = this.HydrateRecommendations(rawData);
		let html = "";
		let carousel = void 0;
		const recRecent = document.querySelector("#rec-recent");
		const recNoSearch = document.querySelector("#rec-nosearch");

		for (const key in recommendationList)
		{
			switch (key)
			{
				case "search_page.rr1":
				case "search_page.m-rr1":
					if (recRecent !== null)
					{
						carousel = new ProductCarousel("rec-recent", rawData[0].strategy_message, recommendationList[key]);
						carousel.AddToCart = true;
						html = HcProductCard(carousel);
						recRecent.outerHTML = html;
						this.ConfigureThemeAddItems("#rec-recent");
					}

					break;

				case "search_page.rr2":
					if (recNoSearch !== null)
					{
						carousel = new ProductCarousel("rec-nosearch", TextResource.GetTextByCulture('Feature_Recommendations_Searched'), recommendationList[key]);
						carousel.AddToCart = true;
						carousel.EnableSlider = true;
						html = HcProductCard(carousel);
						recNoSearch.outerHTML = html;
						this.ConfigureFourUpCarousel("#rec-nosearch");
						this.ConfigureThemeAddItems("#rec-nosearch");
					}

					break;
			}
		}
	};

	///<summary>Records click through to Rich Relevance.</summary>
	public HandleRecommendationClick = (): void =>
	{
		const rrLinks = document.querySelectorAll("a[data-rr-url]:not([data-rr-url=''])");

		if (rrLinks.length > 0)
		{
			rrLinks.forEach((rrLink) =>
			{
				rrLink.addEventListener("click", (e) =>
				{
					e.preventDefault();
					const target = e.currentTarget as HTMLLinkElement;
					const updateLocation = !target.classList.contains("add-rec");
					const rrUrl = target.getAttribute("data-rr-url");
					const targetUrl = target.href;

					if (rrUrl)
					{
						axios.get(rrUrl)
							.then(() =>
							{
								if (updateLocation)
								{
									window.top.location.href = targetUrl;
								}
							});
					}
					else
					{
						window.top.location.href = targetUrl;
					}
				});
			});
		}
	};

	///<summary>Gets referring category from referring page url.</summary>
	public GetReferringCategory = async (callbackFunction): Promise<void> =>
	{
		this.ReferringCategoryAsyncAPI = typeof callbackFunction !== 'undefined';
		this.GetReferringCategoryCallback = callbackFunction;

		if (document.referrer)
		{
			const categoryID = await this.trackingService.GetReferringCategory();

			if (categoryID !== "0")
			{
				this.ReferrerCategoryID = parseInt(categoryID);
			}

			if (this.ReferringCategoryAsyncAPI)
			{
				this.GetReferringCategoryCallback();
			}
		}
		else if (this.ReferringCategoryAsyncAPI)
		{
			// Call the callback function since we don't need to call the API
			this.ReferrerCategoryID = 0;
			this.GetReferringCategoryCallback();
		}
	};

	// PRIVATE FUNCTIONS
	///<summary>Configures the carousel for the related products (with hover) on the bottom of product detail page.</summary>
	// private ConfigureBottomItems(carouselID, length)
	// {
	// 	let element;
	// 	let carousel;
	// 	let desktopBreakpoint = me.DesktopBreakpoint;

	// 	if ($("html").hasClass("bs"))
	// 	{
	// 		desktopBreakpoint = 992;
	// 	}

	// 	element = $(carouselID);
	// 	carousel = $(carouselID + " .carousel");

	// 	$(carouselID + " .carousel .psr-item").each(function (index, value)
	// 	{
	// 		if (index > 7)
	// 		{
	// 			$(this).addClass("tr");
	// 		}
	// 		else
	// 		{
	// 			$(this).addClass("tl");
	// 		}
	// 	});

	// 	if (Fun.Theme.Media === "desktop")
	// 	{
	// 		let html = "";

	// 		var blanks = 0;
	// 		if (length < 10)
	// 		{
	// 			blanks = 10 - length;
	// 		}

	// 		for (let i = 0; i < blanks; i++)
	// 		{
	// 			html += "<div class=\"rel-prd\" data-blank></div>";
	// 		}

	// 		carousel.append(html);
	// 	}

	// 	carousel.slick({
	// 		accessibility: true,
	// 		slidesToShow: 10,
	// 		slidesToScroll: 10,
	// 		dots: false,
	// 		arrows: true,
	// 		responsive: [
	// 			{
	// 				breakpoint: desktopBreakpoint,
	// 				settings: {
	// 					dots: true,
	// 					arrows: false,
	// 					slidesToShow: 4,
	// 					slidesToScroll: 4
	// 				}
	// 			},
	// 			{
	// 				breakpoint: 540,
	// 				settings: {
	// 					dots: true,
	// 					arrows: false,
	// 					slidesToShow: 3,
	// 					slidesToScroll: 3
	// 				}
	// 			},
	// 			{
	// 				breakpoint: 440,
	// 				settings: {
	// 					dots: true,
	// 					arrows: false,
	// 					slidesToShow: 2,
	// 					slidesToScroll: 2
	// 				}
	// 			}
	// 		]
	// 	});

	// 	if (Fun.Theme.Media === "desktop")
	// 	{
	// 		blanks = $(element).find(".psr-item[data-blank]");

	// 		for (let j = 0; j < blanks.length; j++)
	// 		{
	// 			$(blanks[j]).closest(".slick-slide").attr("data-blank", "");
	// 		}
	// 	}
	// }

	// ///<summary>Configures the recently viewed container behavior.</summary>
	// private ConfigureRightItems(recommendations)
	// {
	// 	const html = GetContainer(recommendations, "RecentlyViewed");
	// 	$("#rcnts").replaceWith(html);

	// 	if (Fun.Theme.Media === "mobile")
	// 	{
	// 		$("#rcnts .rcnt-title").shave(35);
	// 	}
	// 	else
	// 	{
	// 		$("#rcnts .rcnt-title").shave(45);
	// 	}

	// 	// If recently viewed product hasn't been initialized yet
	// 	if (typeof Fun.Client.RecentProduct !== "undefined" && $("html").hasClass("no-rcnt"))
	// 	{
	// 		Fun.Client.RecentProduct.ConfigureRecentlyViewed();
	// 	}

	// 	// Match Page Height to sidebar height on fun.com desktop mode
	// 	if (Fun.Theme.Media === "desktop")
	// 	{
	// 		if ($("#rec-recent-side").length)
	// 		{
	// 			$("#rec-recent-side").css("display", "");
	// 		}
	// 	}
	// }

	// ///<summary>Configures line clamp behavior for larger recommendations.</summary>
	// private ConfigureThemeItems(el)
	// {
	// 	let timer = null;

	// 	$(el).shave(35);

	// 	$(window).on("resize", function ()
	// 	{
	// 		clearTimeout(timer);

	// 		timer = setTimeout(function ()
	// 		{
	// 			$(el).shave(35);
	// 		}, 1000);
	// 	});
	// }

	// private ConfigureHoverRecsCarousel = async (carouselSelector: string): Promise<void> =>
	// {
	// 	const carouselContainer = document.querySelector(carouselSelector) as HTMLElement;

	// 	if (carouselContainer !== null)
	// 	{
	// 		const carousel = carouselContainer.querySelector(".carousel") as HTMLElement;

	// 		if (carousel !== null)
	// 		{
	// 			const mobileSetup = enquire.register(Media.MediaMobile, {
	// 				setup: async () =>
	// 				{
	// 					console.log("setup");

	// 					const fancyapps = await Fancyapps.Import();
	// 					const carouselInstance = new fancyapps.Carousel(carousel, {
	// 						slidesPerPage: 2,
	// 						center: false,
	// 						Navigation
	// 					});
	// 				},
	// 				deferSetup: true
	// 			});
	// 		}
	// 	}
	// };

	///<summary>Configures the recently viewed container behavior.</summary>
	private ConfigureRightItems = (recommendations, recRecentSide: HTMLElement): void =>
	{
		const html = RecentlyViewedSide(recommendations);
		const rcnts: HTMLElement = document.getElementById("rcnts");

		if (rcnts !== null)
		{
			rcnts.innerHTML = html;

			// const rightInstance = Collapse.getInstance("#rcnts");
			// //const rightToggle = document.querySelector("#rec-recent-side [data-bs-toggle='collapse']");

			// enquire.register(`(min-width: ${Media.Breakpoints.Lg.Min}px) and (max-width: ${Media.Breakpoints.Xl.Max}px)`, {
			// 	match: (): void =>
			// 	{
			// 		rightInstance.hide();
			// 	},
			// 	unmatch: (): void =>
			// 	{
			// 		rightInstance.show();
			// 	}
			//	});

			recRecentSide.classList.remove("d-xxl-none");
			recRecentSide.classList.add("d-xxl-block");
		}
	};

	// If recently viewed product hasn't been initialized yet
	// if (typeof Fun.Client.RecentProduct !== "undefined" && $("html").hasClass("no-rcnt"))
	// {
	// 	Fun.Client.RecentProduct.ConfigureRecentlyViewed();
	// }

	// Match Page Height to sidebar height on fun.com desktop mode
	// if (Fun.Theme.Media === "desktop")
	// {
	// 	if ($("#rec-recent-side").length)
	// 	{
	// 		$("#rec-recent-side").css("display", "");
	// 	}
	// z

	private ConfigureFourUpCarousel = async (carouselSelector: string): Promise<void> =>
	{
		const mobileCount = 2;
		const desktopCount = 4;
		let displayCount = 0;
		const container = document.querySelector(carouselSelector) as HTMLElement;

		if (Media.IsMobile)
		{
			displayCount = mobileCount;
		}
		else
		{
			displayCount = desktopCount;
		}

		if (container !== null)
		{
			const carousel = container.querySelector(".fourup-carousel") as HTMLElement;
			const fancyapps = await Fancyapps.Import();

			const carouselInstance = new fancyapps.Carousel(carousel, {
				slidesPerPage: displayCount,
				center: false,
				Navigation: false
			});

			enquire.register(Media.MediaMobile, {
				match: () =>
				{
					carouselInstance.options.slidesPerPage = mobileCount;
					carouselInstance.updatePage();
				},
				unmatch: () =>
				{
					carouselInstance.options.slidesPerPage = desktopCount;
					carouselInstance.updatePage();
				}
			});
		}
	};

	///<summary>Configures the carousel for the theme (with  to cart) on the middle of the product detail page.</summary>
	private ConfigureThemeAddItems = (el = ".rel-acc"): void =>
	{
		const container = document.querySelector(el) as HTMLElement;

		if (container !== null)
		{
			const sizeSelectors = container.querySelectorAll("select");
			const addRec = container.querySelectorAll(".add-rec");

			if (sizeSelectors.length > 0)
			{
				sizeSelectors.forEach((select) =>
				{
					select.addEventListener("change", (e) =>
					{
						const el = e.currentTarget as HTMLSelectElement;
						const price = el.options[el.selectedIndex].getAttribute("data-price");
						const item = el.closest(".ps-item");
						const priceEl = item.querySelector(".price");
						priceEl.textContent = Tenant.CurrencySymbol + price;
					});
				});
			}

			//Unbinding needs to be done so that there are not 2 addToCart click events on the buttons.
			//This happens when Initialize is call twice because both our own recommendations and 3rd party
			//recommendations are being used on the page.
			//The namespacing on the click event is necessary so that other click events are not removed.
			//In this case, a click event is used to record click-throughs to the 3rd party.
			if (addRec.length > 0)
			{
				addRec.forEach((addRec) =>
				{
					addRec.removeEventListener("click", this.AddRecHandler);
					addRec.addEventListener("click", this.AddRecHandler);
				});
			}
		}
	};

	private AddRecHandler = (e: Event): void =>
	{
		e.preventDefault();
		const target = e.currentTarget as HTMLElement;

		const form = target.closest(".ps-item, .item");
		const select = form.querySelector("select") as HTMLSelectElement;

		const productID = target.getAttribute("data-productid");
		const productSizeID = select.value;
		const cartItemOriginID = target.getAttribute("data-origin-id");
		const quantity = 1;

		const product = {
			ProductID: productID,
			ProductSizeID: productSizeID,
			Quantity: quantity,
			CartItemOriginID: cartItemOriginID
		};

		this.cart.AddProduct(product);
	};

	// ///<summary>Renders recommendation container.</summary>
	// private GetContainer(recommendations, templateName, templateOptions)
	// {
	// 	const template = Handlebars.templates[templateName];
	// 	const html = template(recommendations);

	// 	return html;
	// }

	private HydrateLocalPlacement = (placementName, rawData): object =>
	{
		const recommendationList = {};
		const recommendations = [];
		let item = void 0;
		let sizeData = void 0;
		let sizes = void 0;
		let size = void 0;
		const currencyCookie = CookieManager.Cookies.Currency;

		const currencySymbol = CookieManager.GetCookie(currencyCookie.Key, currencyCookie.CurrencySymbol);
		const items = JSON.parse(rawData);

		for (let j = 0; j < items.length; j++)
		{
			sizeData = items[j].Sizes;
			sizes = [];

			for (let k = 0; k < sizeData.length; k++)
			{
				const currencyId = CookieManager.GetCookie(currencyCookie.Key, currencyCookie.CurrencyID);
				size = new ProductSize(sizeData[k].ProductSizeID, sizeData[k].Size, sizeData[k].Price, sizeData[k].RegularPrice, sizeData[k].DisplayOrder);
				sizes.push(size);
			}

			sizes = sizes.sort(
				function (a, b)
				{
					return a.DisplayOrder - b.DisplayOrder;
				});

			item = new Product(items[j].ProductID,
				sizes,
				items[j].LinkTitle,
				items[j].Url,
				items[j].ThumbnailUrl,
				items[j].Price,
				items[j].IsOnClearance,
				items[j].IsOnSale,
				items[j].IsPreOrder,
				items[j].Rating,
				currencySymbol,
				items[j].IsExclusive,
				items[j].MadeByUs,
				null);

			recommendations.push(item);
		}

		if (recommendations.length > 0)
		{
			recommendationList[placementName] = recommendations;
		}

		return recommendationList;
	};

	private HydratePlacement = (placementName, items, recommendationList, currencySymbol, isApi): void =>
	{
		let recommendations = [];
		let item = void 0;
		let sizeData = void 0;
		let sizes = void 0;
		let size = void 0;

		recommendations = [];

		for (let j = 0; j < items.length; j++)
		{
			let currencyFound = false;
			sizes = [];
			if (isApi)
			{
				sizeData = JSON.parse(items[j].attributes.size_info);
			}
			else
			{
				sizeData = JSON.parse(items[j].size_info);
			}

			for (let k = 0; k < sizeData.length; k++)
			{
				const currencyId = Tenant.CurrencyID;
				let price = void 0;
				let regularPrice = void 0;

				for (let m = 0; m < sizeData[k].Prices.length; m++)
				{
					if (sizeData[k].Prices[m].CurrencyID.toString() === currencyId)
					{
						currencyFound = true;
						price = sizeData[k].Prices[m].Price;
						regularPrice = sizeData[k].Prices[m].RegularPrice;
						break;
					}
				}

				if (currencyFound)
				{
					if (sizeData[k].Quantity > 0)
					{
						size = new ProductSize(sizeData[k].ProductSizeID, sizeData[k].Size, price, regularPrice, sizeData[k].DisplayOrder);
						sizes.push(size);
					}
				}
			}

			if (currencyFound)
			{
				sizes = sizes.sort(
					function (a, b)
					{
						return a.DisplayOrder - b.DisplayOrder;
					});

				if (isApi)
				{
					item = new Product(items[j].id,
						sizes,
						items[j].name,
						items[j].attributes.relative_url,
						items[j].imageURL,
						items[j].priceCents / 100,
						items[j].attributes.is_on_clearance === "True",
						items[j].attributes.is_on_sale === "True",
						items[j].attributes.is_preorder === "True",
						items[j].rating,
						currencySymbol,
						items[j].attributes.exclusive_item === "True",
						items[j].attributes.made_by_us === "True",
						items[j].clickTrackingURL);
				}
				else
				{
					item = new Product(items[j].id,
						sizes,
						items[j].name,
						items[j].relative_url,
						items[j].image_url,
						items[j].price,
						items[j].is_on_clearance === "True",
						items[j].is_on_sale === "True",
						items[j].is_preorder === "True",
						items[j].rating,
						currencySymbol,
						items[j].exclusive === "True",
						items[j].made_by_us === "True",
						items[j].link_url);
				}

				recommendations.push(item);
			}
		}

		if (recommendations.length > 0)
		{
			recommendationList[placementName] = recommendations;
		}

		return recommendationList;
	};

	// ///<summary>Tranforms raw data from api call.</summary>
	// private HydrateApiRecommendations(rawData)
	// {
	// 	const recommendationList = {};

	// 	try
	// 	{
	// 		if (rawData)
	// 		{
	// 			const currencySymbol = Tenant.CurrencySymbol;

	// 			for (let i = 0; i < rawData.placements.length; i++)
	// 			{
	// 				this.HydratePlacement(rawData.placements[i].placement, rawData.placements[i].recommendedProducts, recommendationList, currencySymbol, true);
	// 			}
	// 		}

	// 		return recommendationList;
	// 	}
	// 	catch (ex)
	// 	{
	// 		//continue
	// 	}
	// }

	///<summary>Tranforms raw data from javascript call.</summary>
	private HydrateRecommendations = (rawData): object =>
	{
		const recommendationList = {};

		try
		{
			if (rawData)
			{
				const currencySymbol = Tenant.CurrencySymbol;

				for (let i = 0; i < rawData.length; i++)
				{
					this.HydratePlacement(rawData[i].placement_name, rawData[i].items, recommendationList, currencySymbol, false);
				}
			}

			return recommendationList;
		}
		catch (ex)
		{
			//continue
		}
	};

	// ///<summary>Get header recommendations from cache.</summary>
	// private GetCache()
	// {
	// 	let result;
	// 	const storageKey = "HEADER_RECS";

	// 	try
	// 	{
	// 		result = sessionStorage.getItem(storageKey);
	// 	}
	// 	catch (e)
	// 	{
	// 		result = null;
	// 	}

	// 	if (result)
	// 	{
	// 		result = JSON.parse(result);
	// 	}

	// 	return result;
	// }

	// ///<summary>Get header item recommendation from cache.</summary>
	// private GetCacheItem(key)
	// {
	// 	let currentRecommendations;
	// 	const timestamp = Date.now(); // current date time in milliseconds
	// 	const cacheDuration = 3600000; // 1 hour in milliseconds

	// 	let currentValues = this.GetCache();
	// 	if (!currentValues)
	// 	{
	// 		currentValues = [];
	// 	}

	// 	for (let i = 0; i < currentValues.length; i++)
	// 	{
	// 		if (currentValues[i][0] === key)
	// 		{
	// 			if (currentValues[i][1] >= timestamp - cacheDuration)
	// 			{
	// 				currentRecommendations = currentValues[i][2];
	// 			}
	// 			break;
	// 		}
	// 	}

	// 	if (currentRecommendations)
	// 	{
	// 		currentRecommendations = JSON.parse(currentRecommendations);
	// 	}

	// 	return currentRecommendations;
	// }

	// ///<summary>Saves header recommendations to cache.</summary>
	// private SetCacheItem(key, value)
	// {
	// 	if (value)
	// 	{
	// 		const storageKey = "HEADER_RECS";
	// 		let found = false;
	// 		const jsonValue = JSON.stringify(value);
	// 		const timestamp = Date.now(); // current date time in milliseconds

	// 		const newRecommendations = [];
	// 		newRecommendations.push(key);
	// 		newRecommendations.push(timestamp);
	// 		newRecommendations.push(jsonValue);

	// 		let currentValues = this.GetCache();
	// 		if (!currentValues)
	// 		{
	// 			currentValues = [];
	// 		}

	// 		for (let i = 0; i < currentValues.length; i++)
	// 		{
	// 			if (currentValues[i][0] === key)
	// 			{
	// 				currentValues[i] = newRecommendations;
	// 				found = true;
	// 				break;
	// 			}
	// 		}

	// 		if (!found)
	// 		{
	// 			currentValues.push(newRecommendations);
	// 		}

	// 		try
	// 		{
	// 			sessionStorage.setItem(storageKey, JSON.stringify(currentValues));
	// 		}
	// 		catch (e)
	// 		{
	// 			//don't save
	// 		}
	// 	}
	// }
}